import React from "react";
import ReactDOM from "react-dom"; 

import { BrowserRouter } from "react-router-dom";

import "./css/style.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./css/style.css";
import "./css/skin/skin-1.css";
import "./styles/globals.css";
import "./styles/switcher.css";

import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
    <App></App>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
